// extracted by mini-css-extract-plugin
export var durationAndBadgeContainer = "Pp6Aq";
export var emojiIcon = "AFWvC";
export var eventListItemDateTime = "BuwfN";
export var eventListItemDetailsSection = "hjKza";
export var eventListItemPrimaryCard = "z4WFD";
export var eventListItemSummary = "OSEKU";
export var eventListItemTitle = "uCZwS";
export var greyBackground = "JFZbK";
export var isSelected = "cR3El";
export var singleLine = "LHKdO";
export var titleAndBadgeContainer = "Z8GBd";
export var titleAndHostContainer = "cLweE";